import { Outlet } from "react-router-dom";
import Header from "./header/Header";
import React, {Fragment, useState, useEffect, useRef, useContext} from "react";
import Footer from "./footer/Footer";
import Favicon from "../components/Favicon"
import SezioneA from "../components/SezioneA";
import SezioneB from "../components/SezioneB";
import SezioneC from "../components/SezioneC";
import Mediazione from "../components/Mediazione";
import NessunaSezione from "../components/NessunaSezione";
import Cart from "../components/Cart";
import ButtonScaricaPdf from "../components/ButtonScaricaPdf";
import AgevolazioniFiscali from "../components/AgevolazioniFiscali";
import cameraCntx from "../contexts/CameraCntx";

function RootLayout() {
    const { selectedMediazione, sezioneA, sezioneB, sezioneC, isSezioniLoading, isSezioniLoaded } = useContext(cameraCntx);
    const cartRef = useRef(null);
    const parentRef = useRef(null);
    const [cartInitialTop, setcartInitialTop] = useState(null);
    const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1024);

    useEffect(() => {
        const handleResize = () => {
            setIsLargeScreen(window.innerWidth >= 1024);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const parentRect = parentRef.current;
            if(!cartRef.current) {
                return null;
            } else {
                const cartRect = cartRef.current;
                if (cartRef.current && !cartInitialTop) {
                    setcartInitialTop(cartRef.current.offsetTop);
                }
                const scrollPosition = window.scrollY;
                const parentBottom = parentRect.offsetHeight - cartRect.offsetHeight;

                if (scrollPosition <= parentBottom) {
                    cartRef.current.style.position = 'fixed';
                    cartRef.current.style.top = `${cartInitialTop}px`;
                } else {
                    cartRef.current.style.position = 'relative';
                    cartRef.current.style.top = `${parentRect.offsetHeight - cartRect.offsetHeight}px`;
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [cartInitialTop]);

    const anySezionePresent = !!sezioneA || !!sezioneB || !!sezioneC;
    const showSpinner = isSezioniLoading && !isSezioniLoaded;

    return (
        <Fragment >
            <Favicon />
            <Header />
            <br/><br/>
            <br/><br/>
            <br/><br/>
            <main>
                <div className={`container${selectedMediazione ? "-fluid me-5" : ""} col-12 d-flex`} ref={parentRef}>
                    <div className={`container-fluid text-start col-md-${isLargeScreen && selectedMediazione ? '9' : '12'} mb-5 me-1 order-first`}>
                        <Mediazione/>
                        <br/>
                        {showSpinner ? (
                            <div style={{
                                minHeight: 200,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                margin: "16px 0"
                            }}>
                                <div className="spinner-border text-primary" role="status" aria-hidden="true" style={{ width: 48, height: 48 }}></div>
                            </div>
                        ) : (
                            <>
                                {!anySezionePresent ? (
                                    <NessunaSezione />
                                ) : (
                                    <>
                                        <SezioneA />
                                        <br />
                                        <SezioneB />
                                        <br />
                                        <SezioneC />
                                        <br />
                                    </>
                                )}
                            </>
                        )}
                        <br/>
                        <ButtonScaricaPdf/>
                    </div>
                    {isLargeScreen && selectedMediazione && (
                        <div className="container text-start col-md-3 mb-1 p-3 order-last d-none d-lg-block">
                            <div ref={cartRef} style={{ maxWidth: "300px" }}>
                                <Cart />
                            </div>
                        </div>
                    )}
                </div>
                <div className={`container${selectedMediazione ? "-fluid me-5" : ""} col-12 d-flex`}>
                    <div className={`col-md-${isLargeScreen && selectedMediazione ? '9' : '12'} mb-5 me-1`}>
                        <AgevolazioniFiscali/>
                    </div>
                </div>
                <Outlet/>
            </main>
            <Footer/>
        </Fragment>
    );
}

export default RootLayout;
